import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable, BehaviorSubject } from 'rxjs/';
import { Subject } from 'rxjs/Subject';

import { StorageService } from './storage.service';
import { User } from '../models/user.model';

@Injectable()
export class SessionService {

    private userDetails = new BehaviorSubject<User>(new User());

    constructor(private storageService: StorageService) {
        this.userDetails.next(this.storageService.get('user'));
    }

    public user(): Observable<User> {
        return this.userDetails;
    }

    getUserDetails(): User {
        return this.userDetails.getValue();
    }

    setUserDetails(userDetails: User): void {
        this.storageService.set('user', userDetails);
        this.userDetails.next(userDetails)
    }

    updateUserDetails(userDetails: User): void {
        this.userDetails.next(userDetails);
    }
    
    reloadUserDetails(): void {
        this.userDetails.next(this.storageService.get('user'));
    }

    clearUserDetails(): void {
        this.storageService.delete('user');
    }

    getToken(): string {
        return this.storageService.get('access_token');
    }

    decodeToken(token) {
        const payload = token ? JSON.parse(atob(token.split('.')[1])) : null;
        return payload;
    };
}


// WEBPACK FOOTER //
// ./src/app/core/services/session.service.ts